import React, { useState, useEffect } from 'react'

export default function Header() {
  const [activeSection, setActiveSection] = useState('')
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20)

      const sections = ['announcement', 'contact', 'partner']
      const scrollPosition = window.scrollY + 120

      for (const section of sections) {
        const el = document.getElementById(section)
        if (el) {
          const top = el.offsetTop
          const height = el.offsetHeight
          if (scrollPosition >= top && scrollPosition < top + height) {
            setActiveSection(section)
            break
          }
        }
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navLinks = [
    { href: '#announcement', label: 'Announcement', id: 'announcement' },
    { href: '#contact', label: 'Contact', id: 'contact' },
    { href: '#partner', label: 'Partner', id: 'partner' },
  ]

  const handleNavClick = (e, href) => {
    e.preventDefault()
    setMobileMenuOpen(false)
    const target = document.querySelector(href)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0a120d]/95 backdrop-blur-md border-b border-[#1b3424] shadow-lg shadow-black/20'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo & Identity */}
          <a
            href="#top"
            onClick={(e) => handleNavClick(e, '#top')}
            className="flex items-center gap-3.5 group focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 rounded-lg p-1"
          >
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-950 to-[#0e291b] border border-emerald-500/30 flex items-center justify-center text-emerald-400 font-bold tracking-wider text-sm shadow-inner group-hover:border-emerald-400/60 transition-colors">
              <span className="font-extrabold tracking-tight text-white">BFT</span>
            </div>
            <div className="hidden sm:flex flex-col">
              <span className="text-base font-semibold text-white tracking-tight leading-tight group-hover:text-emerald-300 transition-colors">
                Biofuel Technology Global
              </span>
              <span className="text-xs font-medium text-emerald-400/80 tracking-wide uppercase">
                BFT Global
              </span>
            </div>
          </a>

          {/* Desktop Navigation (visible >= 1200px: xl breakpoint in Tailwind) */}
          <nav className="hidden xl:flex items-center gap-1">
            {navLinks.map((item) => {
              const isActive = activeSection === item.id
              return (
                <a
                  key={item.id}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                    isActive
                      ? 'text-emerald-300 bg-emerald-950/60 border border-emerald-800/60'
                      : 'text-neutral-300 hover:text-white hover:bg-white/5 border border-transparent'
                  }`}
                >
                  {item.label}
                </a>
              )
            })}
          </nav>

          {/* Right Action / Status Badge */}
          <div className="flex items-center gap-3">
            <div className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold bg-[#13281a] border border-emerald-800/40 text-emerald-300">
              <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" aria-hidden="true" />
              <span>Midlertidig side</span>
            </div>

            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-xs sm:text-sm font-semibold text-white bg-emerald-700 hover:bg-emerald-600 transition-colors shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
            >
              <i className="fa-solid fa-envelope text-xs" aria-hidden="true" />
              <span>Contact</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}
